module.exports = __webpack_public_path__ + "static/media/loan.62501616.svg";